import { useTranslation } from "react-i18next";

const DEFAULT_DATE_TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export const useLocalizedDateFormat = (): Intl.DateTimeFormat => {
  const { i18n } = useTranslation();
  return Intl.DateTimeFormat(i18n.language, DEFAULT_DATE_TIME_FORMAT_OPTIONS);
};